import { useParams } from "react-router-dom";

export const useSettlementId = () => {
  const params = useParams();
  return params.settlementId as string;
};
